import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface HealerProfileCommentsState {
  healerId?: string;
  healerComment?: string;
  error?: string;
  showCommentDialog: boolean;
}

export const initialHealerProfileCommentsState = () =>
  ({
    healerComment: undefined,
    error: undefined,
    showCommentDialog: false,
  } as HealerProfileCommentsState);

export interface HealerProfileCommentsAction {
  type: 'HEALER_COMMENT_SUCCESS' | 'HEALER_COMMENT_ERROR' | 'RESET' | 'SHOW_COMMENT_DIALOG' | 'HIDE_COMMENT_DIALOG';
  payload?: any;
}

const healerProfileCommentsReducer = (
  state: HealerProfileCommentsState = initialHealerProfileCommentsState(),
  action: HealerProfileCommentsAction
): HealerProfileCommentsState => {
  switch (action.type) {
    case 'HEALER_COMMENT_SUCCESS':
      return initialHealerProfileCommentsState();
    case 'HEALER_COMMENT_ERROR':
      return { ...state, error: extractMessageFromError(action.payload) };
    case 'RESET': {
      return {
        healerComment: undefined,
        error: undefined,
        showCommentDialog: false,
      };
    }
    case 'SHOW_COMMENT_DIALOG': {
      return {
        ...state,
        showCommentDialog: true,
      };
    }
    case 'HIDE_COMMENT_DIALOG': {
      return {
        ...state,
        showCommentDialog: false,
      };
    }
    default:
      return state;
  }
};

export default healerProfileCommentsReducer;
